<template>
	<div class="page5_main_layout_phone">
		<div class="page5_main_img_1">

		</div>
		<div class="page5_sub_menu" v-show="false">
			<div class="page5_sub_menu_title">
				关于我们
			</div>
			<div class="page5_sub_menu_sub_1">
				<div class="page5_sub_item_icon">

				</div>
				公司简介
			</div>

		</div>
		<div class="page5_sub_content">
			<div class="page5_sub_content_title_layout">
				<div class="page5_sub_content_icon"></div>
				<div class="page5_sub_content_title">
					公司简介
				</div>
			</div>
			<div class="page5_sub_content_text_1">
				武汉为之易科技有限公司
			</div>
			<div class="page5_sub_content_text_2">
				武汉为之易科技有限公司作为技术创新驱动的企业，汇聚了一批专业素质高、创新能力强劲、实践经验丰富的研发团队。我们不断推动技术进步，研发了系列先进、可靠的设备，以应对市场的变化。我司的系统方案和产品覆盖了光电行业、新能源行业、电子行业等多个领域，从基础模块到系统集成，全方位满足客户需求。
			</div>
			<div class="page5_sub_content_text_3">
				为之易始终坚持以市场需求为导向的发展策略，整合行业资源，不断提升在自动化行业中的核心竞争力。我们坚信，凭借产品的高度定制性和灵活性，能够精准满足客户的多样化需求，并与客户携手共创辉煌的未来。
			</div>
			<!-- 				<div class="page5_sub_content_img_1">
				</div> -->
			<div class="page5_core_technology_layout">
				<div class="page5_core_technology_title">
					核心技术
				</div>
				<div class="page5_core_technology_menu_layout ">
					<div class="core_technology_menu_item " @mouseover="handleMouseOver(1)"
						:style="core_technology_item == 1 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						图像分割
					</div>
					<div class="core_technology_menu_item" @mouseover="handleMouseOver(2)"
						:style="core_technology_item == 2 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						目标定位
					</div>
					<div class="core_technology_menu_item" @mouseover="handleMouseOver(3)"
						:style="core_technology_item == 3 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						图像分类
					</div>
					<div class="core_technology_menu_item" @mouseover="handleMouseOver(4)"
						:style="core_technology_item == 4 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						无监督学习
					</div>

				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 1">
					<div class="core_technology_item_content_1">
						·利用高分辨率摄像头捕捉产品表面的详细图像，确保每一个像素点都清晰可见。
						<br />·对捕获的图像进行去噪、增强等预处理操作，提高缺陷的可检测性。
						<br />·通过算法对图像进行逐像素分析，识别出微小的缺陷点。
						<br />·利用深度学习模型，对复杂场景下的缺陷进行准确识别和分类。

						<!-- 为了确保产品的质量，我们采用了先进的像素级精准检测技术，旨在识别复杂场景下产品表面的细小缺陷，大大提高了产品的合格率和市场竞争力 -->
						<!-- 进行像素级的精准检测，识别复杂场景下产品表面细小缺陷。 -->
					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						<!-- 适用于产品表面细小缺陷、复杂场景的缺陷检测。 -->
						·检测电路板、显示屏等表面的细小划痕、污点等；
						<br />·检测金属部件、塑料配件等表面的微孔、裂纹等；
						<br />·识别布料上的细微瑕疵、色差等；
						<br />·确保包装材料的无瑕疵，防止污染和泄漏。
					</div>
					<div class="core_technology_item_content_3_title">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_1_1">

						</div>
						<div class="core_technology_img core_technology_1_2">

						</div>
						<div class="core_technology_img core_technology_1_3">

						</div>
					</div>
				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 2">
					<div class="core_technology_item_content_1">
						<!-- 区域级的检测，准确识别目标或缺陷，支持多目标检测和多类缺陷检测。 -->
						·采用先进的区域划分算法，将图像划分为多个子区域，每个区域独立进行深度分析，确保不遗漏任何潜在目标或缺陷。
						<br />·结合深度学习、机器学习等多种技术，训练出高精度的识别模型，能够准确区分不同类型的目标和缺陷。
						<br />·通过优化算法结构，实现同时对多个目标进行检测，有效提高检测效率。
						<br />·系统支持多种类型的缺陷检测，如裂纹、划痕、污点等，满足不同行业的需求。
					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						<!-- 适用于不仅要知道图片里有什么，还要知道这些东西在哪里的场景。比如：在一张街景照片中找出汽车、行人、交通灯的位置。 -->
						·用于检测产品表面的多种缺陷，确保产品质量符合标准。
						<br />·在复杂环境中准确识别多个目标，提升安防监控的智能化水平。
						<br />·检测道路上的多个车辆和行人，为智能交通系统提供准确的数据支持。
						<br />·识别医学影像中的多种病变，辅助医生进行诊断。
					</div>
					<div class="core_technology_item_content_3_title">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_2_1">

						</div>
						<div class="core_technology_img core_technology_2_2">

						</div>
						<div class="core_technology_img core_technology_2_3">

						</div>
					</div>
				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 3">
					<div class="core_technology_item_content_1">
						<!-- 基于图像特征的分类，判断整张图像所属类别，适用于大批量的分类任务。 -->
						·采用先进的图像处理技术，如卷积神经网络、深度学习等，自动提取图像中的关键特征，如颜色、纹理、形状等。
						<br />·构建高效的分类模型，如支持向量机、决策树、随机森林等，基于提取的特征对图像进行分类。
						<br />·利用大量标注数据进行模型训练，通过优化算法提高模型的分类准确率和泛化能力。
						<br />·设计高效的批量处理机制，实现大规模图像数据的高效分类。
					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						<!-- 工业品分类、农副产品分选、定级、缺陷分类。 -->
						·在电商领域，对商品图像进行分类，实现自动化的商品归类和推荐。
						<br />·对医学影像进行分类，辅助医生进行疾病诊断和治疗方案制定。
						<br />·对监控图像进行实时分类，识别异常情况，提升安防效率。
						<br />·工业品分类、农副产品分选、定级、缺陷分类。
					</div>
					<div class="core_technology_item_content_3_title">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_3_1">

						</div>
						<div class="core_technology_img core_technology_3_2">

						</div>
						<div class="core_technology_img core_technology_3_3">

						</div>
					</div>
				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 4">
					<div class="core_technology_item_content_1">
						·无需标注，仅上传正样本进行训练，快速识别新类型的异常或复杂纹理。
						<br />·利用自编码器、生成对抗网络等无监督学习算法，自动学习图像中的特征和模式。
						<br />·通过比较新图像与学习到的正常模式之间的差异，快速识别出异常或复杂纹理。
						<br />·采用迭代优化技术，不断改进模型，提高其对新类型异常的识别能力。


					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						·无监督学习特别适大批量生产的产品良品数量多，而缺陷样本稀少且类型多变的情况。
						<br />·在制造业中，用于快速检测产品表面的缺陷或异常。
						<br />·在视频监控中，实时识别异常行为或异常物体。
						<br />·在医学领域，用于发现影像中的异常病变或复杂纹理。
					</div>
					<div class="core_technology_item_content_3_title">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_4_1">

						</div>
						<div class="core_technology_img core_technology_4_2">

						</div>
						<div class="core_technology_img core_technology_4_3">

						</div>
					</div>
				</div>
				<div class="show_certificate_layout">
					<el-carousel :interval="4000" :autoplay="true" type="card" class="show_certificate_main"
						indicator-position="none">
						<!-- 					<el-carousel-item
											class="show_certificate_item_main"
										>
											<div :class="'show_certificate_item ' + 'show_certificate_zs_0'" ></div>
										</el-carousel-item> -->

						<el-carousel-item class="show_certificate_item_main" v-for="item in 20" :key="item">
							<div :class="'show_certificate_item ' + 'show_certificate_zs_' + item"></div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
		</div>
		<div>

		</div>
	</div>
	<div class="page5_main_layout">
		<div class="page5_main_img_1" style="position: relative;">
			<div style="position: absolute;left: 80px;color: #ffffff;font-size: 60px;bottom: 10px;font-weight: 600;">
				AI赋能,视觉设备解锁工业新视界
			</div>

		</div>
		<!-- <div class="page5_sub_menu">
				<div class="page5_sub_menu_title">
					关于我们
				</div>
				<div class="page5_sub_menu_sub_1">
					<div class="page5_sub_item_icon">
						
					</div>
					公司简介
				</div>

			</div> -->
		<div class="page5_sub_content">
			<div class="page5_sub_content_title_layout">
				<div class="page5_sub_content_icon"></div>
				<div class="page5_sub_content_title">
					公司简介
				</div>
			</div>
			<div class="page5_sub_content_text_1">
				武汉为之易科技有限公司
			</div>
			<div class="page5_sub_content_text_2">
				武汉为之易科技有限公司作为技术创新驱动的企业，汇聚了一批专业素质高、创新能力强劲、实践经验丰富的研发团队。我们不断推动技术进步，研发了系列先进、可靠的设备，以应对市场的变化。我司的系统方案和产品覆盖了光电行业、新能源行业、电子行业等多个领域，从基础模块到系统集成，全方位满足客户需求。
			</div>
			<div class="page5_sub_content_text_3">
				为之易始终坚持以市场需求为导向的发展策略，整合行业资源，不断提升在自动化行业中的核心竞争力。我们坚信，凭借产品的高度定制性和灵活性，能够精准满足客户的多样化需求，并与客户携手共创辉煌的未来。
			</div>
			<!-- <div class="core_advantages_layout">
					
					<div class="core_advantages_title">
						核心优势
					</div>
					<div class="core_advantages_item" >
						<div class="core_advantages_item_title">
							独家算法
						</div>
						<div class="core_advantages_item_text">
							公司研发的一套独家算法融合了国内领先的高性能自主算法结构与前沿AI模型，为检测领域带来全新突破。这套算法在检测精度上表现卓越，可达到±5um同时把误差率控制在1%以内，达到业界先进水平。该算法不仅大幅提升了检测环节的工作效率，也凭借高精准度降低了次品率，从而为企业节省生产成本，显著增强市场竞争力，在推动行业技术进步的道路上迈出重要一步。
						</div>
						<div class="core_advantages_item_icon core_advantages_item_icon_1">
							
						</div>
					</div>
					<div class="core_advantages_item" >
						<div class="core_advantages_item_title">
							软件
						</div>
						<div class="core_advantages_item_text">
							公司完全自主研发，拥有独立的知识产权，软件界面简洁、功能强大，涵盖了行业内常见的多种核心功能，并且在深度和广度上都远超同类产品。无论是数据处理、图像识别、系统控制还是其他复杂任务，我们的软件都能快速、准确地完成，为用户提供卓越的使用体验。此外我们的软件实行单客定制更契合用户需求，支持多平台、多接口交互助力企业构建完整的信息化生态系统。软件从底层架构到上层应用都经过了反复的设计、开发和测试，确保了其稳定性和可靠性。
						</div>
						<div class="core_advantages_item_icon core_advantages_item_icon_2">
							
						</div>
					</div>
					<div class="core_advantages_item" >
						<div class="core_advantages_item_title">
							相机
						</div>
						<div class="core_advantages_item_text">
							搭载 2000 万至 4300 万像素高分辨率数字相机。该相机具备卓越的全视野成像能力，在实现清晰成像的同时，将畸变控制在超低水平。其凭借出色的抗干扰性能，在复杂的工业环境下，也能稳定采集高质量图像，可广泛应用于各类工业检测、机器视觉识别等领域。
						</div>
						<div class="core_advantages_item_icon core_advantages_item_icon_3">
							
						</div>
					</div>
					<div class="core_advantages_item" >
						<div class="core_advantages_item_title">
							镜头
						</div>
						<div class="core_advantages_item_text">
							选用的镜头拥有极高的解像力，不仅确保画面中心清晰锐利，而且画面边缘的清晰度与之保持高度一致，实现近乎零畸变的成像效果。同时，镜头具备卓越的抗震、高低温性能，能够在恶劣的物理环境下，始终保持稳定的成像质量。
						</div>
						<div class="core_advantages_item_icon core_advantages_item_icon_4">
							
						</div>
					</div>
					<div class="core_advantages_item" style="margin-top: -50px;" >
						<div class="core_advantages_item_title">
							光源
						</div>
						<div class="core_advantages_item_text">
							采用准平行光源设计，配置进口多色 LED 颗粒。这种光源能够有效解决产品大面积反光的难题，且光源的衰减漂移极小。经过严格的寿命测试，其理论使用寿命可达 3 年以上，极大地降低了维护成本。此外，光源稳定性强，校正周期长，可实现半年乃至一年校正一次。
						</div>
						<div class="core_advantages_item_icon core_advantages_item_icon_5">
							
						</div>
					</div>
				</div> -->

			<div class="page5_core_technology_layout">
				<div class="page5_core_technology_title">
					核心技术
				</div>
				<div class="page5_core_technology_menu_layout ">
					<div class="core_technology_menu_item " @mouseover="handleMouseOver(1)"
						:style="core_technology_item == 1 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						图像分割
					</div>
					<div class="core_technology_menu_item" @mouseover="handleMouseOver(2)"
						:style="core_technology_item == 2 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						目标定位
					</div>
					<div class="core_technology_menu_item" @mouseover="handleMouseOver(3)"
						:style="core_technology_item == 3 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						图像分类
					</div>
					<div class="core_technology_menu_item" @mouseover="handleMouseOver(4)"
						:style="core_technology_item == 4 ? 'background-color: #00BCFF;color: #ffffff;' : ''">
						无监督学习
					</div>

				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 1">
					<div class="core_technology_item_content_1">
						利用高分辨率摄像头捕捉产品表面的详细图像，确保每一个像素点都清晰可见。
						<br />对捕获的图像进行去噪、增强等预处理操作，提高缺陷的可检测性。
						<br />通过算法对图像进行逐像素分析，识别出微小的缺陷点。
						<br />利用深度学习模型，对复杂场景下的缺陷进行准确识别和分类。

						<!-- 为了确保产品的质量，我们采用了先进的像素级精准检测技术，旨在识别复杂场景下产品表面的细小缺陷，大大提高了产品的合格率和市场竞争力 -->
						<!-- 进行像素级的精准检测，识别复杂场景下产品表面细小缺陷。 -->
					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						<!-- 适用于产品表面细小缺陷、复杂场景的缺陷检测。 -->
						检测电路板、显示屏等表面的细小划痕、污点等；
						<br />检测金属部件、塑料配件等表面的微孔、裂纹等；
						<br />识别布料上的细微瑕疵、色差等；
						<br />确保包装材料的无瑕疵，防止污染和泄漏。
					</div>
					<div class="core_technology_item_content_3_title" style="margin-top: 60px;">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_1_1">

						</div>
						<div class="core_technology_img core_technology_1_2">

						</div>
						<div class="core_technology_img core_technology_1_3">

						</div>
					</div>
				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 2">
					<div class="core_technology_item_content_1">
						<!-- 区域级的检测，准确识别目标或缺陷，支持多目标检测和多类缺陷检测。 -->
						采用先进的区域划分算法，将图像划分为多个子区域，每个区域独立进行深度分析，确保不遗漏任何潜在目标或缺陷。
						<br />结合深度学习、机器学习等多种技术，训练出高精度的识别模型，能够准确区分不同类型的目标和缺陷。
						<br />通过优化算法结构，实现同时对多个目标进行检测，有效提高检测效率。
						<br />系统支持多种类型的缺陷检测，如裂纹、划痕、污点等，满足不同行业的需求。
					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						<!-- 适用于不仅要知道图片里有什么，还要知道这些东西在哪里的场景。比如：在一张街景照片中找出汽车、行人、交通灯的位置。 -->
						用于检测产品表面的多种缺陷，确保产品质量符合标准。
						<br />在复杂环境中准确识别多个目标，提升安防监控的智能化水平。
						<br />检测道路上的多个车辆和行人，为智能交通系统提供准确的数据支持。
						<br />识别医学影像中的多种病变，辅助医生进行诊断。
					</div>
					<div class="core_technology_item_content_3_title" style="margin-top: 60px;">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_2_1">

						</div>
						<div class="core_technology_img core_technology_2_2">

						</div>
						<div class="core_technology_img core_technology_2_3">

						</div>
					</div>
				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 3">
					<div class="core_technology_item_content_1">
						<!-- 基于图像特征的分类，判断整张图像所属类别，适用于大批量的分类任务。 -->
						采用先进的图像处理技术，如卷积神经网络、深度学习等，自动提取图像中的关键特征，如颜色、纹理、形状等。
						<br />构建高效的分类模型，如支持向量机、决策树、随机森林等，基于提取的特征对图像进行分类。
						<br />利用大量标注数据进行模型训练，通过优化算法提高模型的分类准确率和泛化能力。
						<br />设计高效的批量处理机制，实现大规模图像数据的高效分类。
					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						<!-- 工业品分类、农副产品分选、定级、缺陷分类。 -->
						在电商领域，对商品图像进行分类，实现自动化的商品归类和推荐。
						<br />对医学影像进行分类，辅助医生进行疾病诊断和治疗方案制定。
						<br />对监控图像进行实时分类，识别异常情况，提升安防效率。
						<br />工业品分类、农副产品分选、定级、缺陷分类。
					</div>
					<div class="core_technology_item_content_3_title" style="margin-top: 60px;">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_3_1">

						</div>
						<div class="core_technology_img core_technology_3_2">

						</div>
						<div class="core_technology_img core_technology_3_3">

						</div>
					</div>
				</div>
				<div class="core_technology_item_content" v-show="core_technology_item == 4">
					<div class="core_technology_item_content_1">
						无需标注，仅上传正样本进行训练，快速识别新类型的异常或复杂纹理。
						<br />利用自编码器、生成对抗网络等无监督学习算法，自动学习图像中的特征和模式。
						<br />通过比较新图像与学习到的正常模式之间的差异，快速识别出异常或复杂纹理。
						<br />采用迭代优化技术，不断改进模型，提高其对新类型异常的识别能力。


					</div>
					<div class="core_technology_item_content_2_title">
						适用场景
					</div>
					<div class="core_technology_item_content_2">
						无监督学习特别适大批量生产的产品良品数量多，而缺陷样本稀少且类型多变的情况。
						<br />在制造业中，用于快速检测产品表面的缺陷或异常。
						<br />在视频监控中，实时识别异常行为或异常物体。
						<br />在医学领域，用于发现影像中的异常病变或复杂纹理。
					</div>
					<div class="core_technology_item_content_3_title" style="margin-top: 60px;">
						行业应用
					</div>
					<div class="core_technology_img_list">
						<div class="core_technology_img core_technology_4_1">

						</div>
						<div class="core_technology_img core_technology_4_2">

						</div>
						<div class="core_technology_img core_technology_4_3">

						</div>
					</div>
				</div>
				<div class="show_certificate_layout">
					<el-carousel :interval="1500" :autoplay="true" type="card" class="show_certificate_main"
						indicator-position="none">
						<!-- 					<el-carousel-item
											class="show_certificate_item_main"
										>
											<div :class="'show_certificate_item ' + 'show_certificate_zs_0'" ></div>
										</el-carousel-item> -->

						<el-carousel-item class="show_certificate_item_main" v-for="item in 20" :key="item">
							<div :class="'show_certificate_item ' + 'show_certificate_zs_' + item"></div>
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<!-- 				<div class="page5_sub_content_img_1">
				</div> -->
		</div>

		<div>

		</div>
	</div>


	<div class="page2_show_menu" v-if="false">
		<div class="page2_show_menu_item" @click="click_page5_show_menu(1)">
			<div>AI识别预警系统</div>
			<a href="#page5_section1" id="page5_show_menu_item_1" style="visibility: hidden;"></a>
		</div>
		<div class="page2_show_menu_item" @click="click_page5_show_menu(2)">
			<div>车辆智能化管理系统</div>
			<a href="#page5_section2" id="page5_show_menu_item_2" style="visibility: hidden;"></a>
		</div>
		<div class="page2_show_menu_item" @click="click_page5_show_menu(3)">
			<div>智能化巡检机器人</div>
			<a href="#page5_section3" id="page5_show_menu_item_3" style="visibility: hidden;"></a>
		</div>
		<!-- 			<div class="page2_show_menu_item" @click="click_page5_show_menu(4)">
					<div>智能化安全巡检机器人</div>
					<a href="#page5_section4"  id="page5_show_menu_item_4" style="visibility: hidden;"></a>
				</div> -->
	</div>
	<div class="page5_main_layout" v-if="false">
		<div class="page5_show_title_line_1" id="page5_section1">
			园区厂房环境、设备监测
		</div>
		<div class="page5_show_title_line_2" id="page5_section2">
			厂区车辆管理
		</div>
		<div class="page5_show_title_line_3" id="page5_section3">
			配电房仪表设备监控
		</div>
		<div class="page5_show_title_line_4" id="page5_section4">
			输煤栈桥区域管理
		</div>


		<div class="page5_show_layout">
			<div class="page5_show_content_1">

			</div>
			<div class="page5_show_content_2">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;">园区厂房潜在问题</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">电力系统故障</div>
					<div>如电网波动、电力中断等可能导致生产中断的事件。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">设备故障</div>
					<div>如发电机过载、轴承损坏等可能导致设备停机或事故的故障。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">火灾风险</div>
					<div>高温设备附近可能存在火灾隐患，AI系统可以识别烟雾或火焰。</div>
				</div>

				<div style="margin-top: 20px;text-align: left;text-indent: 40px;">
					针对以上问题，可以使用配置智能化的<span style="color: #00aaff;">AI识别预警系统</span>，通过<span
						style="color: #00aaff;">AI识别预警系统</span>，能够实现对这些潜在危险的实时监控和预警，提高运营效率，保障人员安全，降低事故风险。
				</div>
			</div>

			<div class="page5_show_content_3">

			</div>
			<div class="page5_show_content_4">

			</div>
			<div class="page5_show_content_5">

			</div>
			<div class="page5_show_content_6">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">AI识别预警系统</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·高度准确性：</span>
					能够准确识别设备的潜在故障、异常行为。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·实时响应性：</span>
					具备实时响应能力，一旦发现异常，应能迅速生成预警。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·稳定与鲁棒性：</span>
					具有高精度的识别和分析能力，同时应具有抗干扰、抗噪声和抗环境变化的能力。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·自动化与智能化：</span>
					能自动化执行巡检任务，通过AI学习和优化，提高预警的准确性和效率，减少人工干预。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·实时监控与数据分析：</span>
					系统应能实时监控设备状态。
				</div>
			</div>

			<div class="page5_show_content_7">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;">厂区车辆管理潜在问题</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">复杂环境</div>
					<div>车牌识别需要高度精确。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">精度要求</div>
					<div>如发电机过载、轴承损坏等可能导致设备停机或事故的故障。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">实时性</div>
					<div>车牌识别系统需要实时响应。</div>
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">数据隐私性</div>
					<div>确保数据的隐私性和合规性。</div>
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div style="font-weight: 600;">系统集成</div>
					<div>车牌识别系统与现有的厂内监控、门禁等系统需兼容集成。</div>
				</div>
				<div style="margin-top: 20px;text-align: left;text-indent: 40px;">
					针对以上问题，可以使用智能化的厂区<span style="color: #00aaff;">车辆智能化管理系统</span>，
					通过厂区<span style="color: #00aaff;">车辆智能化管理系统</span>，够实现对车辆的高效、安全和智能管理，提高运营效率，降低运营成本。
				</div>
			</div>
			<div class="page5_show_content_8">

			</div>
			<div class="page5_show_content_9">

			</div>
			<div class="page5_show_content_10">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">车辆智能化管理系统</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·车牌信息识别精度：</span>
					高精度的车牌信息识别能力。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·系统处理速度：</span>
					实时响应，确保车辆的快速进出。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·车辆追踪与定位：</span>
					实时追踪和定位车辆的位置。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·安全监控：</span>
					具备车辆安全监控功能，如超速、疲劳驾驶、违规行为等。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·安全性与隐私保护：</span>
					处理车牌信息时，确保数据的安全性和隐私保护。
				</div>
			</div>

			<div class="page5_show_content_11">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;">配电房潜在问题</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·高压电的接触可能导致严重的电击伤害。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·电气设备过热或短路可能导致火灾。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·长期接触高压设备可能会产生电磁辐射。</div>
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·高压设备故障可能导致电力中断。</div>
				</div>

				<div style="margin-top: 20px;text-align: left;text-indent: 40px;">
					针对以上问题，可以使用<span
						style="color: #00aaff;">智能化巡检机器人</span>进行全天候监测配电房内仪表设备状态和数据，解决传统人工巡检效率低、检测质量分散、手段单一、设备全生命周期管理等问题。
				</div>
			</div>
			<div class="page5_show_content_12">

			</div>
			<div class="page5_show_content_13">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">智能化巡检机器人</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;margin-left: 180px;">
					<span style="font-weight: 600;color: #00aaff;">·预测准确性：</span>
					准确预测和识别高压设备的异常，如电缆过热、破损等。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;margin-left: 180px;">
					<span style="font-weight: 600;color: #00aaff;">·预警速度：</span>
					能快速响应，一旦发现异常，应能立即通知维护人员并启动应急处理程序。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;margin-left: 180px;">
					<span style="font-weight: 600;color: #00aaff;">·实时监控与数据分析：</span>
					实时监控设备状态，并通过大数据分析，提供故障预警和预防性维护。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;margin-left: 180px;">
					<span style="font-weight: 600;color: #00aaff;">·可扩展性：</span>
					随着电厂规模的扩大，高压配电房可能增加新的设备和线路，应能适应变化。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;margin-left: 180px;">
					<span style="font-weight: 600;color: #00aaff;">·精度与稳定性：</span>
					具备高精度的设备状态监测和故障定位能力。
				</div>
			</div>

			<div class="page5_show_content_14">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;">输煤栈桥区域潜在问题</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·皮带输送机、抓斗机等设备卷入人员。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·煤炭产生大量粉尘，遇明火引发爆炸。</div>
				</div>

				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·电力设备的短路或漏电可能导致 触电事故。</div>
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<div>·煤尘和废水可能泄漏，造成 环境污染 等问题。</div>
				</div>

				<div style="margin-top: 20px;text-align: left;text-indent: 40px;">
					针对以上问题，在输煤栈桥区域可以使用<span style="color: #00aaff;">智能化巡检机器人</span>，替代传统人工管理人员低效率、易漏检的安全管理操作。
				</div>
			</div>
			<div class="page5_show_content_15">

			</div>
			<div class="page5_show_content_16">

			</div>
			<div class="page5_show_content_17">
				<div style="font-weight: 600;text-align: center;text-indent: 0px;color: #00aaff;">智能化巡检机器人</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·高精度识别：</span>
					准确识别煤炭质量和输送设备的状态。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·预警与响应：</span>
					应具备实时响应能力。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·精度与可靠性：</span>
					应具有高精度的定位和识别能力，确保巡检结果的准确性。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·自动化与智能化：</span>
					能实现自动化巡检，减少人工干预，提高效率。
				</div>
				<div style="margin-top: 10px;text-align: left;text-indent: 40px;">
					<span style="font-weight: 600;color: #00aaff;">·数据分析与决策支持：</span>
					能收集并分析大量数据，生成报告，为管理层提供决策支持。
				</div>
			</div>



			<!-- <div class="page2_show_content_5">
				
			</div>
			<div class="page2_show_title_line_2" id="page5_section2">
				FEP-光纤端面研磨机
			</div>
			<div class="page2_show_content_6">
				<span style="font-weight: 600;" >FEP-光纤端面研磨机</span>
				<br />
				<div class="page2_show_content_2_text">
						FEP-光纤端面研磨机用于裸光纤端面研磨，以微型独立研磨主机为主体，通过粗磨、细 磨和抛光等多道抛磨工艺， 将光纤端面包层和纤芯研磨出不同角度的斜面和形状， 提高光学性能和可靠性。 设备配备分度圆调节角度， 外置千分尺调节光纤伸展长度和研磨压
						力， 快拆式裸纤适配器可夹持不同直径的光纤， 待磨光纤端面角度和形状可人为设定和 控制。适用于通讯器件特种光纤、医疗光纤、能量传输光纤端面异形研磨。
				</div>
			</div>
			<div class="page2_show_content_7">
				
			</div>
			<div class="page2_show_title_line_3" id="page5_section3">
				LAMS-激光器老化监控设备
			</div>
			<div class="page2_show_content_8" >
				
			</div>
			<div class="page2_show_content_9">
				<span style="font-weight: 600;">LAMS-激光器老化监控设备</span>
				<br />
				<div class="page2_show_content_2_text">
						FEP-光纤端面研磨机用于裸光纤端面研磨，以微型独立研磨主机为主体，通过粗磨、细 磨和抛光等多道抛磨工艺， 将光纤端面包层和纤芯研磨出不同角度的斜面和形状， 提高光学性能和可靠性。 设备配备分度圆调节角度， 外置千分尺调节光纤伸展长度和研磨压
						力， 快拆式裸纤适配器可夹持不同直径的光纤， 待磨光纤端面角度和形状可人为设定和 控制。适用于通讯器件特种光纤、医疗光纤、能量传输光纤端面异形研磨。
				</div>
				<div class="page2_show_content_3_text">
						<div class="page2_show_content_3_text_item">
							·柜体容纳老化层数及路数可根据要求定制
						</div>
						<div class="page2_show_content_3_text_item">
							·模块化设计，可维护、拓展性良好
						</div>
						<div class="page2_show_content_3_text_item">
							·兼容水冷及风冷散热
						</div>
						<div class="page2_show_content_3_text_item">
							·光斑模式，光谱实时检测
						</div>
						<div class="page2_show_content_3_text_item">
							·实时监控激光器隔离器表面温度、光功率变化
						</div>
						<div class="page2_show_content_3_text_item">
							·老化数据实时反馈及储存
						</div>
				</div>
			</div>
			<div class="page2_show_content_10">
				
			</div> -->

		</div>
	</div>
	<Footer></Footer>

</template>

<script>
import request from "@/utils/request";
import Footer from '@/components/Footer'

export default {
	name: "page5",
	components: {
		Footer
	},
	data() {
		return {
			base_url: SERVER_URL,
			core_technology_item: 1,
		}
	},
	mounted() {
		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

		this.$GLOBAL.methods.init_header_menu("page5")
	},
	methods: {
		handleMouseOver(value) {
			this.core_technology_item = value
		},
		click_page5_show_menu(index) {

			document.getElementById("page5_show_menu_item_" + index).click();
			// console.log(document.getElementById("page5_show_menu_item_"+index))
			// window.localStorage.setItem("show_id",item.id);
			// this.$router.push("/main/page_api_1")
		},


	}
}
</script>

<style></style>